import { PageNames } from 'shared/constants/appConstants';
import { mapPageNameToFiltersList } from 'invoices/constants/FiltersOptionsData';
import { AwsAutoCompleteFields, AwsCommonFields } from 'shared/constants/awsConstants';
import { modifiedPurchaseOptionToDisplay } from 'shared/utils/awsUtils';
import LabelCoordinator from 'shared/modules/labelCoordinator';

export const createFiltersDistinctValuesDisplayMap = (valKey, values) => {
  const createDivisionDisplayMap = (valArr) => {
    const map = new Map();
    if (valArr) {
      valArr.forEach((val) => {
        map.set(val.divisionName, val.divisionNameDisplay);
      });
    }
    return map;
  };
  const createCostCenterDisplayMap = (valArr) => {
    const map = new Map();
    if (valArr) {
      valArr.forEach((val) => {
        map.set(val.costCenterName, val.costCenterNameDisplay);
      });
    }
    return map;
  };
  const createBusinessMappingDisplayMap = (valArr) => {
    const map = new Map();
    if (valArr) {
      valArr.forEach((val) => {
        map.set(val.id, val.name);
      });
    }
    return map;
  };
  const createPurchaseOptionDisplayMap = (valArr) => {
    const map = new Map();
    if (valArr) {
      valArr.forEach((val) => {
        map.set(val.purchaseOptionName, modifiedPurchaseOptionToDisplay(val.purchaseOptionDisplayName));
      });
    }
    return map;
  };
  const keyToDisplayFuncCreator = {
    division: createDivisionDisplayMap,
    costcenter: createCostCenterDisplayMap,
    businessmappingviewpoints: createBusinessMappingDisplayMap,
    businessmapping: createBusinessMappingDisplayMap,
    purchaseoption: createPurchaseOptionDisplayMap,
  };
  return keyToDisplayFuncCreator[valKey](values);
};

export const prepareFilterMap = (
  mergedFilters,
  pageName,
  cloudType,
  definedArrFilters,
  currentDisplayedAccountFeatures,
) => {
  const mapFilters = new Map();
  const arrFilters =
    definedArrFilters || mapPageNameToFiltersList.get(pageName)(cloudType, currentDisplayedAccountFeatures);
  if (!arrFilters) {
    return mapFilters;
  }
  arrFilters.forEach((filterName) => {
    if (mergedFilters.has(filterName) || AwsAutoCompleteFields.includes(filterName)) {
      mapFilters.set(filterName, mergedFilters.get(filterName) || []);
    }
  });
  return mapFilters;
  // if (pageName === PageNames.SAVINGS_PLANS_ANALYZER) {
  // TODO - uncomment once we will suport service and os filter
  //   this.updateSpAnalyzerSpecificFilters(mapFilters);
  // }
};

export const getPageFiltersRaw = (
  mergedFilters,
  pageName,
  cloudType,
  filterOptions,
  currentDisplayedAccountFeatures,
) => {
  if (mergedFilters.size === 0) {
    return new Map();
  }

  const mapFilters = prepareFilterMap(mergedFilters, pageName, cloudType, null, currentDisplayedAccountFeatures);
  if (pageName === PageNames.FILTER_GROUP && filterOptions) {
    filterOptions.forEach(({ name, filter }) => {
      if (mapFilters.get(name)) {
        mapFilters.set(name, mapFilters.get(name).filter(filter));
      }
    });
  }
  if (pageName === PageNames.BILLING_RULES_NEW && filterOptions) {
    filterOptions.forEach(({ name, filter }) => {
      if (!filter) {
        mapFilters.delete(name);
      }
    });
  }
  return mapFilters;
};

export const formatCUEFilterLabels = (field, options) => {
  switch (field) {
    case AwsCommonFields.SERVICE: {
      return options.map((option) => ({
        ...option,
        label: LabelCoordinator.getDataKeyDisplayName('cueDisplayCoordinator', option.label),
      }));
    }

    case AwsCommonFields.CUSTOM_TAGS:
    case AwsCommonFields.GOVERNANCE_TAGS_KEYS: {
      return options.map(({ value }) => ({
        label: value?.split?.(': ')?.[1],
        value: value,
      }));
    }
    default: {
      return options;
    }
  }
};
